import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { calculateScore } from '../../utils/scoreCalculation';

/**
 * LiveScore Component
 * Displays real-time score breakdown during gameplay
 *
 * @param {object} scorecard - Current scorecard state {red, yellow, green, blue, penalties}
 * @param {object} closedRows - Object indicating which rows are closed
 * @param {object} rowClosers - Object with arrays of player names who closed each row
 * @param {string} playerName - Name of the current player
 */
const LiveScore = ({ scorecard, closedRows, rowClosers, playerName }) => {
  const { t } = useLanguage();

  // Calculate current score including lock bonus if player closed a row
  const { breakdown } = calculateScore(scorecard, closedRows, rowClosers, playerName);

  return (
    <div className="live-score-display">
      <h3>📊 {t('liveScore.yourScore')}</h3>
      <table className="live-score-table">
        <thead>
          <tr>
            <th className="red-column">{t('colors.red')}</th>
            <th className="yellow-column">{t('colors.yellow')}</th>
            <th className="green-column">{t('colors.green')}</th>
            <th className="blue-column">{t('colors.blue')}</th>
            <th className="penalty-column">{t('penalties.label')}</th>
            <th className="total-column">{t('gameOver.total')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="red-column">{breakdown.red}</td>
            <td className="yellow-column">{breakdown.yellow}</td>
            <td className="green-column">{breakdown.green}</td>
            <td className="blue-column">{breakdown.blue}</td>
            <td className="penalty-column">{breakdown.penalties}</td>
            <td className="total-column"><strong>{breakdown.total}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default LiveScore;
